interface IDeleteIconProps {
  readonly className?: string;
}

export function DeleteIcon({ className }: IDeleteIconProps) {
  return (
    <svg
      width={18}
      height={18}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 18 18"
      className={className ? className : 'self-center inline-block'}
    >
      <g
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M2.75 4.25H15.25" />
        <path d="M6.75 4.25V2.75C6.75 2.198 7.198 1.75 7.75 1.75H10.25C10.802 1.75 11.25 2.198 11.25 2.75V4.25" />
        <path d="M13.5 6.75L13.1 14.355C13.044 15.417 12.166 16.25 11.103 16.25H6.89798C5.83398 16.25 4.95698 15.417 4.90098 14.355L4.50098 6.75" />
      </g>
    </svg>
  );
}
